"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebSocketServerGeneric = void 0;
var websocket_1 = require("websocket");
var dispatcher_1 = require("../../dispatcher");
var logger_1 = require("../../logger");
var WebSocketServerGeneric = (function () {
    function WebSocketServerGeneric(server, services, logger, open, dispatcher, handlers) {
        if (open === void 0) { open = true; }
        if (dispatcher === void 0) { dispatcher = undefined; }
        if (handlers === void 0) { handlers = undefined; }
        var _this = this;
        this._logger = logger;
        if (!dispatcher) {
            this._dispatcher = new dispatcher_1.Dispatcher();
        }
        else {
            this._dispatcher = dispatcher;
        }
        services.forEach(function (s) {
            _this._dispatcher.register(s);
        });
        this._handlers = handlers;
        this._connections = [];
        this._server = new websocket_1.server({
            httpServer: server
        });
        this._server.on('request', function (request) {
            _this._logger.logf(logger_1.LogLevel.Trace, 'Incoming connection from ' + request.origin);
            var connection = request.accept(null, request.origin);
            if (_this._handlers) {
                if (!_this._handlers.onConnect(null, null)) {
                    connection.close();
                    return;
                }
            }
            _this._connections.push(connection);
            connection.on('message', function (message) {
                if (message.type !== 'utf8' || !message.utf8Data) {
                    _this._logger.logf(logger_1.LogLevel.Warning, 'Non textual format is not supported. ', message);
                    return;
                }
                var data = message.utf8Data;
                throw new Error('Not implemented!');
            });
            connection.on('error', function (err) {
                _this._logger.logf(logger_1.LogLevel.Error, 'Error received: ', err);
            });
            connection.on('close', function (code, desc) {
                if (_this._handlers) {
                    _this._handlers.onDisconnect(null);
                }
                _this._connections = _this._connections.filter(function (c) { return c !== connection; });
            });
        });
    }
    return WebSocketServerGeneric;
}());
exports.WebSocketServerGeneric = WebSocketServerGeneric;
//# sourceMappingURL=transport.server.websocket.js.map